enum PrioritiesEnum {
	LOW = 'Low',
	MEDIUM = 'Medium',
	HIGH = 'High',
	URGENT = 'Urgent',
}

export default PrioritiesEnum;
